// 接口域名
// const PREFIX = 'http://192.168.2.68:8099';		//昊轩
// const PREFIX = 'http://192.168.2.74:8099';	//文达
// const PREFIX = 'https://mcapi.posedu.com.cn';	//正式
// const PREFIX = 'https://mctestapi.posedu.com.cn';	//测试

// ----------------------部署时接口域名不要动  取的是服务器上的--------------------------
let PREFIX = ''; // 初始化 PREFIX

const PREFIXFun = () => {
  const xhr = new XMLHttpRequest();
  xhr.open('GET', '../../configurationFile.txt', false);
  xhr.send(null);

  if (xhr.status === 200) {
    const data = xhr.responseText;
    console.log("xhr.responseText",xhr.responseText);
    return data.split('\n')[0].indexOf('https://') !== -1 ? data.split('\n')[0] : 'https://mctestapi.posedu.com.cn';
  } else {
    return 'https://mctestapi.posedu.com.cn'; // 返回默认 URL
  }
};

const initializeApi = () => {
  PREFIX = PREFIXFun(); // 直接调用获取 PREFIX
  return {
    'ws': 'ws://192.168.2.68:8099/websocket/', // websocket
    'getCache': PREFIX + '/score/second/console/getCache', // 获取 缓存
    'gerSecondConsoleInfo': PREFIX + '/score/second/console/gerSecondConsoleInfo', // 计时环节等数据
    'drawQuestions': PREFIX + '/score/second/console/drawQuestions', // 提交抽题
    'getPlayerJudges': PREFIX + '/score/fg/jugde/getPlayerJudges', // 评委评分回显
    'playerPOST': PREFIX + '/score/player/', // 选手详情
    'backdrop_list': PREFIX + '/score/config/backdrop_list', // 背景图等
    'grade_rank': PREFIX + '/score/grade/grade_rank', // 选手排行 18618451066
    'grade_final_grade': PREFIX + '/score/grade/grade_final_grade', // 总分展示
    'grade_college_list': PREFIX + '/score/grade/grade_college_list', // 获取学院
    'gradeRankWithSplit': PREFIX + '/score/grade/gradeRankWithSplit', // 轮询选手排行分页等

    'drawing': PREFIX + '/score/player/drawing', // 抽签选手列表
    'drawingShowField': PREFIX + '/score/player/drawingShowField', // 抽签展示字段获取
    'getNowDrawingList': PREFIX + '/score/player/getNowDrawingList', // 获取当前抽签完成选手以及正在抽签选手ID
  };
};

// 立即初始化 API 对象
const api = initializeApi();

export default api; // 导出 api




// WEBPACK FOOTER //
// ./src/router/api.js